/**
 * Color scales for climate indicators
 * Defines color gradients for different indicator types
 *
 * @file Color scale definitions for chart visualization
 */

/**
 * Reference color for charts
 * @type {string}
 */
export const greyColor = '#B6B6B6';

/**
 * Color scales for indicators
 * @type {Object}
 */
export const indicatorsColorScales = {
  darkBlue: {
    ref: greyColor,
    min: '#96D2FA',
    mean: '#6496FA',
    max: '#0A46AF',
  },
  red: {
    ref: greyColor,
    min: '#FAD200',
    mean: '#FA9632',
    max: '#C80000',
  },
  violet: {
    ref: greyColor,
    min: '#B4BEFA',
    mean: '#A082FA',
    max: '#961987',
  },
  blue: {
    ref: greyColor,
    min: '#87D7DC',
    mean: '#55B4D7',
    max: '#196E8C',
  },
  green: {
    ref: greyColor,
    min: '#D7D746',
    mean: '#96C823',
    max: '#286E14',
  },
};
